<template>
  <div class="slidenvbx">
    <transition-group
      :name="`slide_${direction}`"
      tag="div"
      class="d-flex mh-0"
    >
      <div
        :key="activeRoute"
        class="slidenvbx_content"
      >
        <slot
          :name="activeRoute"
          :goForward="goForward"
          :goBackward="goBackward"
          :route="activeRoute"
          >{{ activeRoute }}</slot
        >
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'NavBox',
  props: {},
  data() {
    return {
      direction: 'forward',
      routes: ['root'],
    }
  },
  methods: {
    goForward(route) {
      if (route) {
        this.direction = 'backward'
        this.routes.push(route)
      }
    },
    goBackward() {
      if (this.routes.length > 1) {
        this.direction = 'forward'
        this.routes.pop()
      }
    },
  },
  computed: {
    activeRoute() {
      return this.routes[this.routes.length - 1]
    },
  },
}
</script>

<style lang="scss" scoped>
.slidenvbx {
  overflow: hidden;
  position: relative;
  display: flex;
  flex: 1;
  min-height: 0;
  --transition-duration: 0.22s;
  &_content {
    position: absolute;
    display: flex;
    height: 100%;
    width: 100%;
  }
}

.slide_forward-leave-active,
.slide_backward-enter-active {
  transition: var(--transition-duration);
  position: absolute;
  top: 0;
  left: 0;
}
.slide_forward-enter-active,
.slide_backward-leave-active {
  transition: var(--transition-duration);
  top: 0;
  left: 0;
}
.slide_forward-enter-from {
  opacity: 0;
  transform: translateX(-100px);
}
.slide_forward-leave-to {
  opacity: 0;
  transform: translateX(100px);
}

.slide_backward-enter-from {
  opacity: 0;
  transform: translateX(100px);
}
.slide_backward-leave-to {
  opacity: 0;
  transform: translateX(-100px);
}
</style>
